var map = {
	"./baby_changing.svg": 113,
	"./buggy_park.svg": 114,
	"./cafe.svg": 115,
	"./cloakroom.svg": 116,
	"./disabled_toilet.svg": 117,
	"./discovery_area.svg": 118,
	"./entrance.svg": 119,
	"./exits.svg": 120,
	"./female_toilet.svg": 121,
	"./freddie_mercury_splendid_things.svg": 122,
	"./garden.svg": 123,
	"./gender_neutral_toilet.svg": 124,
	"./information.svg": 125,
	"./lifts.svg": 126,
	"./male_toilet.svg": 127,
	"./sanitation.svg": 128,
	"./shop.svg": 129,
	"./stairs.svg": 130,
	"./steps.svg": 131,
	"./study_area.svg": 132,
	"./tickets.svg": 133,
	"./trail_marker.svg": 43,
	"./you_are_here.svg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;